(function () {
  var roots = document.querySelectorAll('[data-ire5-product-launches-root]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var search = root.querySelector('[data-search]');
    var meta = root.querySelector('[data-search-meta]');
    var modelList = root.querySelector('[data-model-list]');
    var empty = root.querySelector('[data-empty-state]');
    var allRecordsLabel = root.getAttribute('data-all-records-label') || '';
    var resultsSuffix = root.getAttribute('data-results-suffix') || '';

    function cards() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-status-card]'));
    }

    function renderModelList() {
      if (!modelList) return;
      modelList.innerHTML = cards().map(function (card, index) {
        var title = card.querySelector('.ire5-public-status__record-head h2');
        var model = title ? title.textContent.trim() : '';
        return (index ? '<span class="ire5-public-status__model-separator" aria-hidden="true">|</span>' : '')
          + '<button class="ire5-public-status__model-name" type="button" data-filter-model="'
          + model.toLowerCase().replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '">'
          + model.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</button>';
      }).join('');
    }

    function applyFilters() {
      var filter = root.getAttribute('data-active-filter') || 'all';
      var model = root.getAttribute('data-active-model') || '';
      var query = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;
      cards().forEach(function (card) {
        var brand = card.getAttribute('data-brand') || '';
        var status = card.getAttribute('data-status-card') || '';
        var cardModel = card.getAttribute('data-model') || '';
        var text = card.getAttribute('data-search-text') || '';
        var paid = Number(card.getAttribute('data-paid-count')) || 0;
        var target = Number(card.getAttribute('data-target-count')) || 0;
        var filterMatch = filter === 'all'
          || filter === 'launches'
          || filter === status
          || (filter === 'best-sellers' && target > 0 && paid >= target)
          || (filter === 'apple' && brand.indexOf('apple') !== -1)
          || (filter === 'android' && brand.indexOf('samsung') !== -1);
        var matches = filterMatch && (!model || cardModel === model) && (!query || text.indexOf(query) !== -1);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (meta) meta.textContent = query || filter !== 'all' || model ? visible + ' ' + resultsSuffix : allRecordsLabel;
      if (empty) empty.hidden = visible !== 0;
    }

    renderModelList();
    applyFilters();

    root.addEventListener('input', function (event) {
      if (event.target && event.target.matches('[data-search]')) {
        root.removeAttribute('data-active-model');
        applyFilters();
      }
    });

    root.addEventListener('click', function (event) {
      var filterButton = event.target.closest('[data-filter-status]');
      if (filterButton && root.contains(filterButton)) {
        root.querySelectorAll('[data-filter-status]').forEach(function (button) {
          button.classList.toggle('is-active', button === filterButton);
        });
        root.setAttribute('data-active-filter', filterButton.getAttribute('data-filter-status') || 'all');
        root.removeAttribute('data-active-model');
        applyFilters();
        return;
      }
      var modelButton = event.target.closest('[data-filter-model]');
      if (modelButton && root.contains(modelButton)) {
        var next = modelButton.getAttribute('data-filter-model') || '';
        if (next === root.getAttribute('data-active-model')) root.removeAttribute('data-active-model');
        else root.setAttribute('data-active-model', next);
        root.querySelectorAll('[data-filter-model]').forEach(function (button) {
          var active = button.getAttribute('data-filter-model') === root.getAttribute('data-active-model');
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        applyFilters();
        return;
      }
      var clear = event.target.closest('[data-clear-search]');
      if (clear && root.contains(clear)) {
        if (search) search.value = '';
        root.removeAttribute('data-active-model');
        applyFilters();
      }
    });
  });
})();
